"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStoryBroken = exports.isCharacterdIdValid = exports.validateNavigation = exports.getValidationError = exports.isStoryValid = void 0;
const consts_1 = require("../consts");
const story_1 = require("./story");
const isStoryValid = (story) => {
    return story_1.storySchema.isValidSync(story);
};
exports.isStoryValid = isStoryValid;
const getValidationError = (story) => {
    if ((0, exports.isStoryValid)(story)) {
        return undefined;
    }
    try {
        story_1.storySchema.validateSync(story);
        // should never get here
        return undefined;
    }
    catch (e) {
        return e;
    }
};
exports.getValidationError = getValidationError;
const validateNavigation = (story) => {
    return (0, story_1.testStepsNavigation)(story.initialStep).validateSync(story.steps);
};
exports.validateNavigation = validateNavigation;
const isCharacterdIdValid = (possiblyCharId) => {
    return story_1.characterId.isValidSync(possiblyCharId);
};
exports.isCharacterdIdValid = isCharacterdIdValid;
const isStoryBroken = (story) => {
    try {
        if (Object.keys(story).length < 8) {
            return true;
        }
        if (Object.keys(story.characters).length !== 3) {
            return true;
        }
        if (story.initialStep === consts_1.defaultInitialStep) {
            return true;
        }
        return false;
    }
    catch (_a) {
        return true;
    }
};
exports.isStoryBroken = isStoryBroken;
//# sourceMappingURL=validation.js.map